import { Injectable, Inject } from 'ng-metadata/core';
import { loadCSS } from './scriptLoader';
import { StorageUtil } from './infra/storageUtil.service';
const { once, clone } = require("lodash");

const STORAGE_KEYS = {
	ENABLED: "cmIntegrationEnabled",
	STYLSHEET: "cmIntegrationStylesheetUrl"
}

const MESSAGES = {
	NAVIGATE: "NAVIGATE",
	MAIN_NAVS: "MAIN_NAVS",
	OTHER_NAVS: "OTHER_NAVS",
	REQUEST_STYLESHEET: "REQUEST_STYLESHEET",
	LOAD_STYLESHEET: "LOAD_STYLESHEET",
	READY: "READY"
}

@Injectable()
export class CMIntegrationService {

	private enabled: boolean = false;
	private menu: Map<string, any> = new Map();
	
	private performAction: Function;

	private messageHandlers = {
		[MESSAGES.NAVIGATE]: (data: any) => {
			this.navItemAction(this.menu[data.code]);
		},
		[MESSAGES.LOAD_STYLESHEET]: (data: {url: string}) => {
			this.loadIntegrationStylesheet(data.url).then(() => this.communicate({name: MESSAGES.READY}));
		}
	}

	constructor(@Inject('$state') private $state: ng.ui.IStateService,
		@Inject('$translate') private $translate: ng.translate.ITranslateService,
		@Inject('$window') private $window: ng.IWindowService,
		@Inject('$location') private $location: ng.ILocationService,
		private storageUtil: StorageUtil) {
			this.enabled = this.checkEnabled();
			if (this.isEnabled()) {
				this.registerMessageListener();
				this.loadIntegrationStylesheet();
				// this.overrideWindowOpen();
			}
	}

	isEnabled() {
		return this.enabled;
	}
	
	ready() {
		this.communicate({name: MESSAGES.REQUEST_STYLESHEET});
	}

	registerMainNavs = once((menu: { code: string; label: string; action: any; href?: any; }[]) => {
		this.registerNav(MESSAGES.MAIN_NAVS, menu, menu.map((m: any) => m.label), (m: any) => this.$translate.instant(m.label));
	})
	
    registerNavMenu = once((menu: any, getLabel: any, performAction: any) => {
		this.performAction = performAction;
		this.registerNav(MESSAGES.OTHER_NAVS, menu, menu.map((m: any) => getLabel(m)), (el: any) => this.$translate.instant(getLabel(el)));
	})

	private overrideWindowOpen () {
		// TODO: Might need some handling when opening links in new window
	}

	private checkEnabled() {
		// TODO: Consider cases where a link is opened in a new window
		// const hasParent = this.$window.parent && this.$window.parent !== this.$window.window;
		// if (!hasParent) return false;
		const campusm = this.$location.search()["campusm"];
		const hasFlag = typeof campusm !== "undefined";
		const flagTrue = campusm === "true";
		const enabled = flagTrue || (!hasFlag && this.storageUtil.sessionStorage.getItem(STORAGE_KEYS.ENABLED));
		this.storageUtil.sessionStorage.setItem(STORAGE_KEYS.ENABLED, enabled);
		return enabled;
	}
	
	private loadIntegrationStylesheet(stylesheetUrl: string = this.$location.search()["stylesheetUrl"]) {
		if (stylesheetUrl) {
			this.storageUtil.sessionStorage.setItem(STORAGE_KEYS.STYLSHEET, stylesheetUrl);
		} else {
			stylesheetUrl = this.storageUtil.sessionStorage.getItem(STORAGE_KEYS.STYLSHEET);
		}
		return stylesheetUrl ? loadCSS(stylesheetUrl) : Promise.resolve();
	}

	private communicate(message: any) {
		if (this.isEnabled()) {
			this.$window.parent.postMessage(message, "*");
		}
	}

	private registerNav(name: string, menu: any, labels: string[], translate: Function, performAction?: Function) {
		const list = [];
		this.$translate(labels).then(() => {
			menu.forEach((m: {code?: string, label: string, action: any, href?: any}) => {
				const cloned = clone(m);
				if (performAction) { cloned.performAction = true; }
				const code = cloned.code || cloned.label;
				this.menu[code] = cloned;
				list.push({code, label: translate(m), href: m.href});
			});
			this.communicate({name, data: list});
		});
	}

	private navItemAction(item: {action: any, sref?: any, performAction?: boolean}) {
		if (!item) return;
		if (this.performAction && item.performAction) {
			this.performAction(item);
		} else {
			item.action && item.action();
			if (item.sref) {
				const {state, params, opts} = item.sref;
				this.$state.go(state, params, opts);
			}
		}
	}

	private registerMessageListener() {
		this.$window.addEventListener("message", (message: MessageEvent) => {
			const f = this.messageHandlers[message.data.name];
			if (f && typeof f === "function") {
				message.stopImmediatePropagation();
				f(message.data);
				return false;
			}
			return true;
		});
	}

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/cm_integration.service.ts